import Widget from "views/logic/widgets/Widget";
export const _deserializeWidgetConfig = (widget) => Widget.fromJSON(widget).config;
export default _deserializeWidgetConfig;
